<template>
  <div class="report">
    <el-form :model="fieldObj" ref="ruleForm" label-width="180px" class="demo-ruleForm">
      <div v-for="(item, index) in fieldArray" :key="index" :class="item.htmlElements">
        <h2 v-if="item.htmlElements === '标题'">{{ item.showName }}</h2>

        <template v-if="item.htmlElements === '输入框'">
          <el-form-item :label="item.title" :prop="item.showName"
            :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请输入' + item.title, trigger: 'blur' }] : []">
            <el-input v-model="fieldObj[item.showName]" :max="item.fieldLength" :placeholder="item.desc"
              show-word-limit></el-input>
          </el-form-item>
        </template>

        <template v-if="item.htmlElements === '文本域'">
          <el-form-item :label="item.title" class="ccc" :prop="item.showName"
            :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请输入' + item.title, trigger: 'blur' }] : []">
            <el-input type="textarea" rows="4" :placeholder="item.desc" v-model="fieldObj[item.showName]"
              :maxlength="item.fieldLength" show-word-limit></el-input>
          </el-form-item>
        </template>

        <template v-if="item.htmlElements === '日历控件'">
          <el-form-item :prop="item.showName" :label="item.title"
            :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.title, trigger: 'change' }] : []">
            <el-date-picker v-model="fieldObj[item.showName]" :name="item.showName" type="date" format="yyyy-MM-dd"
              value-format="yyyy-MM-dd" :placeholder="item.desc"></el-date-picker>
          </el-form-item>
        </template>

        <template v-if="item.htmlElements === '下拉框'">
          <el-form-item :label="item.title" :prop="item.showName"
            :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.title, trigger: 'change' }] : []">
            <el-select v-model="fieldObj[item.showName]" :placeholder="item.describe">
              <el-option v-for="items in item.list" :key="items.name" :label="items.name" :value="items.value">
              </el-option>
            </el-select>
          </el-form-item>
        </template>

        <template v-if="item.htmlElements === '单选框'">
          <el-form-item :label="item.title" :prop="item.showName"
            :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.title, trigger: 'change' }] : []">
            <template v-for="(child) in item.sex">
              <el-radio v-model="fieldObj[item.showName]" :label="child.value">{{ child.name }}</el-radio>
            </template>
          </el-form-item>
        </template>

        <template v-if="item.htmlElements === '复选框'" class="复选框">
          <el-form-item :label="item.title" :prop="item.showName"
            :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.title, trigger: 'change' }] : []">
            <el-checkbox-group v-model="fieldObj[item.showName]" style="display: inline-block;">
              <template v-for="(child) in item.hobbies">
                <el-checkbox :label="child.name"></el-checkbox>
              </template>
            </el-checkbox-group>

            <el-form-item label="其他" v-if="item.duo" style="display: inline-block;margin-left: 20px;">
              <el-input v-model="fieldObj[item.duoval]" placeholder="请输入内容"></el-input>
            </el-form-item>
          </el-form-item>
        </template>
      </div>
    </el-form>
    <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
  </div>
</template>
<script>
export default {
  name: "Test",
  data() {
    return {
      data: [],
      fieldArray: [
        {
          "htmlElements": "标题",
          "showName": "学生基本信息",
        }, {
          "showName": "axax",
          "title": "学生学号",
          "showValue": "",
          "htmlElements": "输入框",
          "fieldLength": 10,
          "requiredOrNot": 2,
          "desc": "请输入学生学号",
          "rules": [{ required: true, message: '请输入学生学号', trigger: 'blur' }]
        }, {
          "showName": "vbdbf",
          "title": "学生姓名",
          "showValue": null,
          "htmlElements": "输入框",
          "fieldLength": 10,
          "requiredOrNot": 1,
          "desc": "请输入姓名"
        }, {
          "htmlElements": "标题",
          "showName": "危机评估",
        }, {
          "showName": "mjgfhgf",
          "title": "意识（是否清醒，是否服用药物/精神活性物质，现实检验力等）",
          "showValue": null,
          "htmlElements": "输入框",
          "fieldLength": 10,
          "requiredOrNot": 1,
          "desc": "请输入意识（是否清醒，是否服用药物/精神活性物质，现实检验力等）"
        }, {
          "title": "所处情境（所处位置/周围环境）",
          "showName": "ngnffg",
          "showValue": null,
          "htmlElements": "输入框",
          "fieldLength": 10,
          "requiredOrNot": 1,
          "desc": "请输入所处情境（所处位置/周围环境）"
        }, {
          "title": "自知力",
          "showName": "nmjmngh",
          "showValue": null,
          "htmlElements": "输入框",
          "fieldLength": 10,
          "requiredOrNot": 1,
          "desc": "自知力"
        }, {
          "title": "情绪状态（类型/强度等）",
          "showName": "yhnff",
          "showValue": null,
          "htmlElements": "输入框",
          "fieldLength": 10,
          "requiredOrNot": 1,
          "desc": "情绪状态（类型/强度等）"
        }, {
          "title": "主要压力源（应激事件/应激反应）",
          "showName": "fbhjykjuy",
          "showValue": null,
          "htmlElements": "输入框",
          "fieldLength": 10,
          "requiredOrNot": 1,
          "desc": "主要压力源（应激事件/应激反应）"
        }, {
          "htmlElements": "标题",
          "showName": "风险等级",
        }, {
          "title": "风险等级",
          "showName": "mkutjngh",
          "showValue": null,
          "htmlElements": "复选框",
          "requiredOrNot": 1,
          "desc": "请选择爱好",
          "hobbies": [{ name: "红色预警", value: "红色预警" }, { name: "橙色预警", value: "橙色预警" }, { name: "黄色预警", value: "黄色预警" }],
          "duo": true,
          "duoval": null
        }, {
          "htmlElements": "标题",
          "showName": "具体风险情况",
        }, {
          "title": "具体风险情况",
          "showName": "mnhtg,mh",
          "showValue": null,
          "htmlElements": "复选框",
          "requiredOrNot": 1,
          "desc": "请选择爱好",
          "hobbies": [{ name: "自杀、自伤或伤害他人倾向", value: "自杀、自伤或伤害他人倾向" }],
          "duo": false,
          "duoval": null
        }, {
          "title": "关于伤害的情况",
          "showName": "/ihnmfghg",
          "showValue": null,
          "htmlElements": "复选框",
          "requiredOrNot": 1,
          "desc": "请选择爱好",
          "hobbies": [{ name: "自杀想法", value: "自杀想法" }, { name: "自杀计划", value: "自杀计划" }, { name: "自杀未遂", value: "自杀未遂" }, { name: "自杀实施中", value: "自杀实施中" }, { name: "自杀姿态", value: "自杀姿态" }, { name: "被动自杀", value: "被动自杀" }, { name: "自伤自残", value: "自伤自残" }, { name: "伤害他人", value: "伤害他人" }, { name: "扩大性自杀", value: "扩大性自杀" }],
          "duo": false,
          "duoval": null
        }, {
          "title": "关于自杀方式",
          "showName": "vdsvfdv",
          "showValue": null,
          "htmlElements": "复选框",
          "requiredOrNot": 1,
          "desc": "请选择爱好",
          "hobbies": [{ name: "吞咽", value: "吞咽" }, { name: "切割", value: "切割" }, { name: "跳楼", value: "跳楼" }, { name: "服药", value: "服药" }],
          "duo": true,
          "duoval": "xaxa"
        }, {
          "title": "既往自杀相关经历（来访者/重要关系人）",
          "showName": "bnedfbf",
          "showValue": null,
          "htmlElements": "输入框",
          "fieldLength": 10,
          "requiredOrNot": 1,
          "desc": "既往自杀相关经历（来访者/重要关系人）"
        }, {
          "title": "具体描述时间、情况、进程等",
          "showName": "gbvfhbf",
          "showValue": null,
          "htmlElements": "输入框",
          "fieldLength": 10,
          "requiredOrNot": 1,
          "desc": "具体描述时间、情况、进程等"
        }, {
          "title": "疑似出现：",
          "showName": "bfbfbf",
          "showValue": null,
          "htmlElements": "复选框",
          "requiredOrNot": 1,
          "desc": "请选择爱好",
          "hobbies": [{ name: "感知觉障碍", value: "感知觉障碍" }, { name: "思维障碍", value: "思维障碍" }, { name: "注意障碍", value: "注意障碍" }, { name: "记忆障碍", value: "记忆障碍" }, { name: "定向力障碍", value: "定向力障碍" }, { name: "意志障碍", value: "意志障碍" }, { name: "动作与行为障碍", value: "动作与行为障碍" }, { name: "情感障碍", value: "情感障碍" }, { name: "意识障碍", value: "意识障碍" }, { name: "自知力缺失", value: "自知力缺失" }],
          "duo": false,
          "duoval": null
        }, {
          "title": "社会支持系统情况",
          "showName": ",jhjgg",
          "showValue": null,
          "htmlElements": "文本域",
          "fieldLength": 500,
          "requiredOrNot": 1,
          "desc": "（如，最信赖的人，与父母、朋友、导师的关系等）"
        }, {
          "title": "服药情况（药名 药量 是否遵医嘱服药）",
          "showName": "gikm",
          "showValue": null,
          "htmlElements": "文本域",
          "fieldLength": 500,
          "requiredOrNot": 1,
          "desc": "请输入描述"
        }, {
          "title": "出生日期",
          "showName": "vcdd",
          "showValue": null,
          "htmlElements": "日历控件",
          "requiredOrNot": 1,
          "desc": "请选择出生日期"
        }, {
          "title": "职业",
          "showName": "vdvdv",
          "showValue": null,
          "htmlElements": "下拉框",
          "requiredOrNot": 1,
          "desc": "请选择职业",
          "list": [{ name: "医生", value: "doctor" }, { name: "老师", value: "teacher" }, { name: "司机", value: "driver" }]
        }, {
          "title": "多部门会商",
          "showName": "mhmhh",
          "showValue": null,
          "htmlElements": "单选框",
          "requiredOrNot": 1,
          "sex": [{ name: '是', value: "是" }, { name: "否", value: "否" }]
        }],// 表单字段集合
      fieldObj: {},
    }
  },
  mounted() {
    this.getFieldData();
    // setTimeout(function(){
    //   this.fieldArray = [
    //       {
    //         "htmlElements": "标题",
    //         "showName": "学生基本信息",
    //       },{
    //         "showName": "axax",
    //         "title": "学生学号",
    //         "showValue": "",
    //         "htmlElements": "输入框",
    //         "fieldLength": 10,
    //         "requiredOrNot": 2,
    //         "desc":"请输入学生学号",
    //         "rules":[{ required: true, message: '请输入学生学号', trigger: 'blur' }]
    //       },{
    //         "showName": "vbdbf",
    //         "title": "学生姓名",
    //         "showValue": null,
    //         "htmlElements": "输入框",
    //         "fieldLength": 10,
    //         "requiredOrNot": 1,
    //         "desc":"请输入姓名"
    //       },{
    //         "htmlElements": "标题",
    //         "showName": "危机评估",
    //       },{
    //         "showName": "mjgfhgf",
    //         "title": "意识（是否清醒，是否服用药物/精神活性物质，现实检验力等）",
    //         "showValue": null,
    //         "htmlElements": "输入框",
    //         "fieldLength": 10,
    //         "requiredOrNot": 1,
    //         "desc":"请输入意识（是否清醒，是否服用药物/精神活性物质，现实检验力等）"
    //       },{
    //         "title": "所处情境（所处位置/周围环境）",
    //         "showName": "ngnffg",
    //         "showValue": null,
    //         "htmlElements": "输入框",
    //         "fieldLength": 10,
    //         "requiredOrNot": 1,
    //         "desc":"请输入所处情境（所处位置/周围环境）"
    //       },{
    //         "title": "自知力",
    //         "showName": "nmjmngh",
    //         "showValue": null,
    //         "htmlElements": "输入框",
    //         "fieldLength": 10,
    //         "requiredOrNot": 1,
    //         "desc":"自知力"
    //       },{
    //         "title": "情绪状态（类型/强度等）",
    //         "showName": "yhnff",
    //         "showValue": null,
    //         "htmlElements": "输入框",
    //         "fieldLength": 10,
    //         "requiredOrNot": 1,
    //         "desc":"情绪状态（类型/强度等）"
    //       },{
    //         "title": "主要压力源（应激事件/应激反应）",
    //         "showName": "fbhjykjuy",
    //         "showValue": null,
    //         "htmlElements": "输入框",
    //         "fieldLength": 10,
    //         "requiredOrNot": 1,
    //         "desc":"主要压力源（应激事件/应激反应）"
    //       },{
    //         "htmlElements": "标题",
    //         "showName": "风险等级",
    //       },{
    //         "title": "风险等级",
    //         "showName": "mkutjngh",
    //         "showValue": null,
    //         "htmlElements": "复选框",
    //         "requiredOrNot": 1,
    //         "desc":"请选择爱好",
    //         "hobbies":[{ name:"红色预警",value:"红色预警"},{ name:"橙色预警",value:"橙色预警"},{name:"黄色预警",value:"黄色预警"}],
    //         "duo":true,
    //         "duoval":null
    //       },{
    //         "htmlElements": "标题",
    //         "showName": "具体风险情况",
    //       },{
    //         "title": "具体风险情况",
    //         "showName": "mnhtg,mh",
    //         "showValue": null,
    //         "htmlElements": "复选框",
    //         "requiredOrNot": 1,
    //         "desc":"请选择爱好",
    //         "hobbies":[{ name:"自杀、自伤或伤害他人倾向",value:"自杀、自伤或伤害他人倾向"}],
    //         "duo":false,
    //         "duoval":null
    //       },{
    //         "title": "关于伤害的情况",
    //         "showName": "/ihnmfghg",
    //         "showValue": null,
    //         "htmlElements": "复选框",
    //         "requiredOrNot": 1,
    //         "desc":"请选择爱好",
    //         "hobbies":[{ name:"自杀想法",value:"自杀想法"},{ name:"自杀计划",value:"自杀计划"},{ name:"自杀未遂",value:"自杀未遂"},{ name:"自杀实施中",value:"自杀实施中"},{ name:"自杀姿态",value:"自杀姿态"},{ name:"被动自杀",value:"被动自杀"},{ name:"自伤自残",value:"自伤自残"},{ name:"伤害他人",value:"伤害他人"},{ name:"扩大性自杀",value:"扩大性自杀"}],
    //         "duo":false,
    //         "duoval":null
    //       },{
    //         "title": "关于自杀方式",
    //         "showName": "vdsvfdv",
    //         "showValue": null,
    //         "htmlElements": "复选框",
    //         "requiredOrNot": 1,
    //         "desc":"请选择爱好",
    //         "hobbies":[{ name:"吞咽",value:"吞咽"},{ name:"切割",value:"切割"},{ name:"跳楼",value:"跳楼"},{ name:"服药",value:"服药"}],
    //         "duo":true,
    //         "duoval":"xaxa"
    //       },{
    //         "title": "既往自杀相关经历（来访者/重要关系人）",
    //         "showName": "bnedfbf",
    //         "showValue": null,
    //         "htmlElements": "输入框",
    //         "fieldLength": 10,
    //         "requiredOrNot": 1,
    //         "desc":"既往自杀相关经历（来访者/重要关系人）"
    //       },{
    //         "title": "具体描述时间、情况、进程等",
    //         "showName": "gbvfhbf",
    //         "showValue": null,
    //         "htmlElements": "输入框",
    //         "fieldLength": 10,
    //         "requiredOrNot": 1,
    //         "desc":"具体描述时间、情况、进程等"
    //       },{
    //         "title": "疑似出现：",
    //         "showName": "bfbfbf",
    //         "showValue": null,
    //         "htmlElements": "复选框",
    //         "requiredOrNot": 1,
    //         "desc":"请选择爱好",
    //         "hobbies":[{ name:"感知觉障碍",value:"感知觉障碍"},{ name:"思维障碍",value:"思维障碍"},{ name:"注意障碍",value:"注意障碍"},{ name:"记忆障碍",value:"记忆障碍"},{ name:"定向力障碍",value:"定向力障碍"},{ name:"意志障碍",value:"意志障碍"},{ name:"动作与行为障碍",value:"动作与行为障碍"},{ name:"情感障碍",value:"情感障碍"},{ name:"意识障碍",value:"意识障碍"},{ name:"自知力缺失",value:"自知力缺失"}],
    //         "duo":false,
    //         "duoval":null
    //       },{
    //         "title": "社会支持系统情况",
    //         "showName": ",jhjgg",
    //         "showValue": null,
    //         "htmlElements": "文本域",
    //         "fieldLength": 500,
    //         "requiredOrNot": 1,
    //         "desc":"（如，最信赖的人，与父母、朋友、导师的关系等）"
    //       },{
    //         "title": "服药情况（药名 药量 是否遵医嘱服药）",
    //         "showName": "gikm",
    //         "showValue": null,
    //         "htmlElements": "文本域",
    //         "fieldLength": 500,
    //         "requiredOrNot": 1,
    //         "desc":"请输入描述"
    //       },{
    //         "title": "出生日期",
    //         "showName": "vcdd",
    //         "showValue": null,
    //         "htmlElements": "日历控件",
    //         "requiredOrNot": 1,
    //         "desc":"请选择出生日期"
    //       },{
    //         "title": "职业",
    //         "showName": "vdvdv",
    //         "showValue": null,
    //         "htmlElements": "下拉框",
    //         "requiredOrNot": 1,
    //         "desc":"请选择职业",
    //         "list":[{name:"医生",value:"doctor"},{name:"老师",value:"teacher"},{name:"司",value:"driver"}]
    //       },{
    //         "title": "多部门会商",
    //         "showName": "mhmhh",
    //         "showValue": null,
    //         "htmlElements": "单选框",
    //         "requiredOrNot": 1,
    //         "sex":[{name:'是',value:"是"},{name:"否",value:"否"}]
    //     }]

    // },500)
  },
  methods: {
    getFieldData() {
      let response = this.fieldArray;
      for (let i = 0; i < response.length; i++) {
        let item = response[i];
        if (item.htmlElements === '复选框') {
          this.$set(this.fieldObj, item.showName, []);
        } else {
          this.$set(this.fieldObj, item.showName, item.showValue);
        }
      }
    },
    submitForm(formName) { // 提交验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
        } else {
          return false;
        }
      });
    },
  },
}
</script>

<style>
.report {
  background-color: #fff;
}

.report h2 {
  padding-top: 14px;
  margin-bottom: 14px;
}

.report .标题 {
  width: 100%;
}

.report .el-form>div {
  margin-left: 14px;
}

.report .输入框 input {
  width: initial;
  width: 500px;
}

.report .el-input__inner {
  width: initial;
}

.report .el-form-item__label {
  width: initial !important;
  display: inline-block;
  text-align: right;
  min-width: 90px;
  text-align: left;
}

.report .el-form-item__content {
  margin-left: initial !important;
  display: inline-block;
}

.report .ccc .el-form-item__content {
  width: 50%;
}

.复选框 .el-form-item__label {
  min-width: 40px !important;
}
</style>
